import { PulseFilters, PulsePaginatedFilters } from 'api/pulse/types'
import { format as dateFormat } from 'date-fns'

const pulseKey = ['pulse']
const pulsePerformanceKey = [...pulseKey, 'performance']
const pulseCostKey = [...pulseKey, 'cost']
const fillRateMetricsKey = [...pulsePerformanceKey, 'fillRateMetrics']
const fillRateTimeseriesKey = [...pulsePerformanceKey, 'fillRateTimeseries']
const fillRateByNoticeTimeseriesKey = [
  ...pulsePerformanceKey,
  'fillRateByNoticeTimeseries',
]
const fillRateByCompanyKey = [...pulsePerformanceKey, 'fillRateByCompany']
const shiftNoticeMetricsKey = [...pulsePerformanceKey, 'shiftNoticeMetrics']
const shiftNoticeTimeseriesKey = [
  ...pulsePerformanceKey,
  'shiftNoticeTimeseries',
]
const fillPayNoticeByLocationKey = [
  ...pulsePerformanceKey,
  'fillPayNoticeByLocation',
]
const payRateTimeseriesKey = [...pulsePerformanceKey, 'payRateTimeseries']
const payRateByPositionKey = [...pulsePerformanceKey, 'payRateByPosition']
const payRateByMarketKey = [...pulsePerformanceKey, 'payRateByMarket']
const payRateByLocationKey = [...pulseCostKey, 'payRateByLocation']
const payRateMarketByLocationKey = [...pulseCostKey, 'payRateMarketByLocation']
const spendTimeseriesKey = [...pulseCostKey, 'spendTimeseries']
const spendPerWorkerTimeseriesKey = [
  ...pulseCostKey,
  'spendPerWorkerTimeseries',
]
const spendMetricsKey = [...pulseCostKey, 'spendMetrics']
const spendByLocationKey = [...pulseCostKey, 'spendByLocation']
const payRateMetricsKey = [...pulseCostKey, 'payRateMetrics']
const ratingMetricsKey = [...pulsePerformanceKey, 'ratingMetrics']
const ratingsTimeseriesKey = [...pulsePerformanceKey, 'ratingsTimeseries']
const topComplimentsKey = [...pulsePerformanceKey, 'topCompliments']
const topComplaintsKey = [...pulsePerformanceKey, 'topComplaints']
const topWorkersKey = [...pulsePerformanceKey, 'topWorkers']
const ratingsByLocationKey = [...pulsePerformanceKey, 'ratingsByLocation']
const pulsePositionTypesKey = [...pulseKey, 'positionTypes']
const pulseCompaniesKey = [...pulseKey, 'companies']

export function getPulseCompaniesKey() {
  return [...pulseCompaniesKey]
}

export function getPulsePositionTypesKey(filters: PulseFilters) {
  return [...pulsePositionTypesKey, filters.companyIds?.join(',')]
}

export function getFillRateMetricsKey(filters: PulseFilters) {
  return [
    ...fillRateMetricsKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getFillPayNoticeByLocationKey(filters: PulsePaginatedFilters) {
  return [
    ...fillPayNoticeByLocationKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}

export function getFillRateByNoticeTimeseriesKey(filters: PulseFilters) {
  return [
    ...fillRateByNoticeTimeseriesKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getFillRateTimeseriesKey(filters: PulseFilters) {
  return [
    ...fillRateTimeseriesKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getShiftNoticeMetricsKey(filters: PulseFilters) {
  return [
    ...shiftNoticeMetricsKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getFillRateByCompanyKey(filters: PulsePaginatedFilters) {
  return [
    ...fillRateByCompanyKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}

export function getShiftNoticeTimeseriesKey(filters: PulseFilters) {
  return [
    ...shiftNoticeTimeseriesKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getPayRateTimeseriesKey(filters: PulseFilters) {
  return [
    ...payRateTimeseriesKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getPayRateByPositionKey(filters: PulsePaginatedFilters) {
  return [
    ...payRateByPositionKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}

export function getPayRateByMarketKey(filters: PulsePaginatedFilters) {
  return [
    ...payRateByMarketKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}

export function getPayRateByLocationKey(filters: PulsePaginatedFilters) {
  return [
    ...payRateByLocationKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}

export function getPayRateMarketByLocationKey(filters: PulsePaginatedFilters) {
  return [
    ...payRateMarketByLocationKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}

export function getSpendTimeseriesKey(filters: PulseFilters) {
  return [
    ...spendTimeseriesKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getSpendPerWorkerTimeseriesKey(filters: PulseFilters) {
  return [
    ...spendPerWorkerTimeseriesKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getSpendMetricsKey(filters: PulseFilters) {
  return [
    ...spendMetricsKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getSpendByLocationKey(filters: PulsePaginatedFilters) {
  return [
    ...spendByLocationKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}

export function getPayRateMetricsKey(filters: PulseFilters) {
  return [
    ...payRateMetricsKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
  ]
}

export function getRatingMetricsKey(filters: PulseFilters) {
  return [
    ...ratingMetricsKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
  ]
}

export function getRatingsTimeseriesKey(filters: PulseFilters) {
  return [
    ...ratingsTimeseriesKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
  ]
}

export function getTopComplimentsKey(filters: PulsePaginatedFilters) {
  return [
    ...topComplimentsKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.page,
    filters.pageSize,
  ]
}

export function getTopComplaintsKey(filters: PulsePaginatedFilters) {
  return [
    ...topComplaintsKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.page,
    filters.pageSize,
  ]
}

export function getTopWorkersKey(filters: PulseFilters) {
  return [
    ...topWorkersKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
  ]
}

export function getRatingsByLocationKey(filters: PulsePaginatedFilters) {
  return [
    ...ratingsByLocationKey,
    dateFormat(filters.dateFrom, 'yyyy-MM-dd'),
    dateFormat(filters.dateTo, 'yyyy-MM-dd'),
    filters.companyIds?.join(','),
    filters.positionTypes?.join(','),
    filters.timePeriod,
    filters.page,
    filters.pageSize,
  ]
}
